
import React from "react";

import styles from "../../../styles/opening-hours.module.scss";

import { Select } from "../../../shared/components/Select";
import { Icon } from "../../../shared/components/core/Icon";
import { Button } from "../../../shared/components/Button";

import WorkingTime from "../../plugins/core/schema/configurations/WorkingTime";


export default class Horary extends React.Component {
	constructor(props) {
		super(props);

		this.getCloseTime = this.getCloseTime.bind(this);

		const WeekDays = WorkingTime.getWeekDays('pt-br');
		this.state = {
			WeekDays,
		};
	}

	getOpenTimes() {
		const { before, beforeDay } = this.props;

		let open = null;
		if (beforeDay) {
			open = this.addTime(beforeDay.close[beforeDay.close.length - 1], 0);
		} else {
			open = '00:00';
		}

		if (before) {
			open = this.addTime(before.close, 15);
		}

		const times = this.getTimeRange(open);

		return times.map((time) => {
			return {
				value: time,
				label: time
			};
		});
	}

	normalizeHour(hour) {
		return parseInt(hour.replace(':', ''), 10);
	}

	getCloseTime() {
		const { close, isLast, nextDay } = this.props;

		if (isLast && nextDay) {
			return `${close} (${this.getTomorrowName()})`;
		}

		return close;
	}

	getCloseTimes() {
		const { afterDay } = this.props;

		const close = this.props.open ? this.addTime(this.props.open) : '00:00'
		const finalPeriod = !afterDay || afterDay.open.length === 0 ? '23:45' : this.subTime(afterDay.open[0]);

		const todayPeriods = close === '24:00' ? [] : this.getTimeRange(close);
		const tomorrowPeriods = this.getTimeRange('00:00', finalPeriod, true);
		const times = [...todayPeriods, ...tomorrowPeriods];

		return times.map((time) => {
			return {
				value: time,
				label: time
			};
		});
	}

	addTime(time, value = 15) {
		const [hour, minutes] = String(time).split(':');
		const finalHour =
			parseInt(minutes, 10) === 45
				? parseInt(hour, 10) + 1
				: parseInt(hour, 10);
		let finalMinutes = parseInt(minutes, 10) + value;
		finalMinutes = finalMinutes === 60 ? 0 : finalMinutes;

		return `${`${finalHour}`.padStart(2, '0')}:${`${finalMinutes}`.padStart(
			2,
			'0'
		)}`;
	}

	getTomorrowName() {
		const { WeekDays } = this.state;
		const { weeknum } = this.props;
		return WeekDays[(weeknum + 1) % 7];
	}

	getYesterday() {
		const { WeekDays } = this.state;
		const { beforeDay } = this.props;

		if (!beforeDay) {
			return null;
		}
		return WeekDays[(beforeDay.weeknum + 1) % 7];
	}

	getTimeRange(begin = '00:00', end = '23:45', label = false) {
		const timeRange = this.generateTimeRange(label);
		const indexOfBegin = timeRange.indexOf(begin);
		const indexOfEnd = label
			? timeRange.map((time) => time.substr(0, 5)).indexOf(end)
			: timeRange.indexOf(end);

		const validTimeRange = timeRange.slice(
			indexOfBegin !== -1 ? indexOfBegin : 0,
			indexOfEnd !== -1 ? indexOfEnd + 1 : timeRange.length - 1
		);

		return validTimeRange;
	}

	generateTimeRange(label = false) {
		const timeHourOptions = [];
		for (let hours = 0; hours < 24; hours++) {
			for (let minutes = 0; minutes < 4; minutes++) {
				timeHourOptions.push(
					`${`${hours}`.padStart(2, '0')}:${`${minutes * 15}`.padStart(
						2,
						'0'
					)}${label ? ` (${this.getTomorrowName()})` : ''}`
				);
			}
		}
		return timeHourOptions;
	}
	render() {
		const { periodName, active, nextWeekDay, allowRemove, disabled } = this.props;

		return (
			<div
				className={`${styles.period} ${active ? styles.active : styles.inactive}`}
			>
				<div className={styles.header}>
					<div>
						<p>Período {periodName}</p>
						{allowRemove &&
							<Button
								design="default-icon-mini"
								onClick={() => this.props.onRemoveHorary()}
								disabled={this.props.disabled}
							>
								<Icon name="trash-alt" size="1x" />
							</Button>
						}
					</div>
				</div>

				<div className={styles.schedules}>
					<p className={styles.start}>Início</p>
					<Select
						design="mini"
						options={this.getOpenTimes()}
						value={this.props.open}
						disabled={this.props.disabled}
						onChange={(event) => this.props.onChangeHorary('open', event.target.value)}
					/>
					<span className={styles.divisor}></span>
					<p className={styles.end}>
						Fim {nextWeekDay && <span>({nextWeekDay})</span>}
					</p>
					<Select
						design="mini"
						options={this.getCloseTimes()}
						value={this.getCloseTime()}
						disabled={this.props.disabled}
						onChange={(event) => this.props.onChangeHorary('close', event.target.value)}
					/>
				</div>
			</div>
		)
	}

}